export const tagOptions = [
    { label: '<Meta/>', code: 'meta', self_closing: true },
    { label: '<Link/>', code: 'link', self_closing: true },
    { label: '<Base/>', code: 'base', self_closing: true },
    { label: '<Image/>', code: 'img', self_closing: true },
    { label: '<Title></Title>', code: 'title', self_closing: false },
    { label: '<Style></Style>', code: 'style', self_closing: false },
    { label: '<Script></Script>', code: 'script', self_closing: false },
    { label: '<Noscript></Noscript>', code: 'noscript', self_closing: false },
    { label: '<Template></Template>', code: 'template', self_closing: false }
];

export const LANG_OPTIONS = [
    { code: 'EN', name: 'English /en', disabled: false },
    { code: 'ES', name: 'Español /es', disabled: false },
    { code: 'FR', name: 'Français /fr', disabled: false },
];

/** Local noun used in UI copy for crossings on an entry page. */
export const TERMINOLOGY_OPTIONS = [
    { code: 'garita', name: 'Garita / Garitas', singular: 'garita', plural: 'garitas', gender: 'f' },
    { code: 'fila', name: 'Fila / Filas', singular: 'fila', plural: 'filas', gender: 'f' },
    { code: 'puente', name: 'Puente / Puentes', singular: 'puente', plural: 'puentes', gender: 'm' },
    { code: 'crossing', name: 'Crossing / Crossings', singular: 'crossing', plural: 'crossings', gender: 'm' },
    { code: 'custom', name: 'Custom', singular: '', plural: '', gender: 'f' },
];

export const TERMINOLOGY_GENDER_OPTIONS = [
    { code: 'f', name: 'Femenino · una / esta / la' },
    { code: 'm', name: 'Masculino · un / este / el' },
];

export function resolveTerminology(raw) {
    const fallback = { preset: 'garita', singular: 'garita', plural: 'garitas', gender: 'f' };
    if (!raw || typeof raw !== 'object') return fallback;
    const preset = String(raw.preset || '').trim().toLowerCase();
    const option = TERMINOLOGY_OPTIONS.find((o) => o.code === preset);
    if (option && option.code !== 'custom') {
        return {
            preset: option.code,
            singular: option.singular,
            plural: option.plural,
            gender: option.gender,
        };
    }
    const singular = String(raw.singular || '').trim() || fallback.singular;
    const plural = String(raw.plural || '').trim() || fallback.plural;
    const gender = raw.gender === 'm' ? 'm' : 'f';
    return { preset: 'custom', singular, plural, gender };
}

export const PAGE_TYPES = [
    { code: 'entryPage', name: 'Entry page' },
    { code: 'contentPage', name: 'Content page', disabled: true },
];

/** URL segment for a border code. Canada is /canada; the stored code stays `ca`. */
export function borderPathSegment(code) {
    if (code === 'ca') return 'canada';
    return code || '';
}

export const BORDER_OPTIONS = [
    { code: 'ca', name: 'Canadian Border', disabled: false, type: 'departure', lang_code: 'country_of_canada' },
    { code: 'mexico', name: 'Mexican Border', disabled: false, type: 'departure', lang_code: 'country_of_mexico' },
    { code: 'us', name: 'US Border', disabled: false, type: 'arrival', lang_code: 'country_of_usa' }
];

export const BORDER_STATES = [
  // Mexican States
  { code: 'BC', name: 'Baja California', border: 'mexico', disabled: false },
  { code: 'SON', name: 'Sonora', border: 'mexico', disabled: false },
  { code: 'CHIH', name: 'Chihuahua', border: 'mexico', disabled: false },
  { code: 'COAH', name: 'Coahuila', border: 'mexico', disabled: false },
  { code: 'NL', name: 'Nuevo León', border: 'mexico', disabled: false },
  { code: 'TAMS', name: 'Tamaulipas', border: 'mexico', disabled: false },
  // US States
  { code: 'WA', name: 'Washington', border: 'us', disabled: false },
  { code: 'ID', name: 'Idaho', border: 'us', disabled: false },
  { code: 'MT', name: 'Montana', border: 'us', disabled: false },
  { code: 'ND', name: 'North Dakota', border: 'us', disabled: false },
  { code: 'MN', name: 'Minnesota', border: 'us', disabled: false },
  { code: 'WI', name: 'Wisconsin', border: 'us', disabled: false },
  { code: 'MI', name: 'Michigan', border: 'us', disabled: false },
  { code: 'NY', name: 'New York', border: 'us', disabled: false },
  { code: 'MA', name: 'Massachusetts', border: 'us', disabled: false },
  { code: 'VT', name: 'Vermont', border: 'us', disabled: false },
  { code: 'NH', name: 'New Hampshire', border: 'us', disabled: false },
  { code: 'ME', name: 'Maine', border: 'us', disabled: false },
  // Canadian States
  { code: 'CAL', name: 'California', border: 'us', disabled: false },
  { code: 'AZ', name: 'Arizona', border: 'us', disabled: false },
  { code: 'NM', name: 'New Mexico', border: 'us', disabled: false },
  { code: 'TX', name: 'Texas', border: 'us', disabled: false },
  { code: 'BTC', name: 'British Columbia', border: 'ca', disabled: false },
  { code: 'ALB', name: 'Alberta', border: 'ca', disabled: false },
  { code: 'MAN', name: 'Manitoba', border: 'ca', disabled: false },
  { code: 'ONT', name: 'Ontario', border: 'ca', disabled: false },
  { code: 'QUE', name: 'Quebec', border: 'ca', disabled: false },
  { code: 'NB', name: 'New Brunswick', border: 'ca', disabled: false } 
];

export const BORDER_CITIES_BY_STATE = {
  // Mexican cities
  'BC': [
    { code: 'BC001', name: 'Tijuana', disabled: false },
    { code: 'BC002', name: 'Mexicali', disabled: false },
    { code: 'BC003', name: 'Tecate', disabled: false },
    { code: 'BC004', name: 'Ensenada', disabled: false },
    { code: 'BC005', name: 'Los Algodones', disabled: false }
  ],
  'SON': [
    { code: 'SON001', name: 'Nogales', disabled: false },
    { code: 'SON002', name: 'San Luis Río Colorado', disabled: false },
    { code: 'SON003', name: 'Agua Prieta', disabled: false },
    { code: 'SON004', name: 'Sonoyta', disabled: false },
    { code: 'SON005', name: 'Naco', disabled: false }
  ],
  'CHIH': [
    { code: 'CHIH001', name: 'Ciudad Juárez', disabled: false },
    { code: 'CHIH002', name: 'Ojinaga', disabled: false },
    { code: 'CHIH003', name: 'Palomas', disabled: false },
    { code: 'CHIH004', name: 'Praxedis G. Guerrero', disabled: false },
    { code: 'CHIH005', name: 'Ojinaga', disabled: false },
    { code: 'CHIH006', name: 'Puerto Palomas', disabled: false }
  ],
  'COAH': [
    { code: 'COAH001', name: 'Piedras Negras', disabled: false },
    { code: 'COAH002', name: 'Acuña', disabled: false },
    { code: 'COAH003', name: 'Nava', disabled: false },
    { code: 'COAH004', name: 'Zaragoza', disabled: false }
  ],
  'NL': [
    { code: 'NL001', name: 'Anáhuac', disabled: false },
    { code: 'NL002', name: 'Los Aldamas', disabled: false },
    { code: 'NL003', name: 'General Bravo', disabled: false },
    { code: 'NL004', name: 'Colombia', disabled: false }
  ],
  'TAMS': [
    { code: 'TAMS001', name: 'Matamoros', disabled: false },
    { code: 'TAMS002', name: 'Reynosa', disabled: false },
    { code: 'TAMS003', name: 'Nuevo Laredo', disabled: false },
    { code: 'TAMS004', name: 'Ciudad Miguel Alemán', disabled: false },
    { code: 'TAMS005', name: 'Camargo', disabled: false },
    { code: 'TAMS006', name: 'Ciudad Miguel Alemán', disabled: false },
    { code: 'TAMS007', name: 'Nuevo Progreso', disabled: false }
  ],
  // United States cities
  'CAL': [
    { code: 'CAL001', name: 'San Ysidro', disabled: false },
    { code: 'CAL002', name: 'Otay Mesa', disabled: false },
    { code: 'CAL003', name: 'Tecate', disabled: false },
    { code: 'CAL004', name: 'Calexico', disabled: false },
    { code: 'CAL005', name: 'Andrade', disabled: false }
  ],
  'AZ': [
    { code: 'AZ001', name: 'Lukeville', disabled: false },
    { code: 'AZ002', name: 'Sasabe', disabled: false },
    { code: 'AZ003', name: 'Nogales', disabled: false },
    { code: 'AZ004', name: 'San Luis', disabled: false },
    { code: 'AZ005', name: 'Naco', disabled: false },
    { code: 'AZ006', name: 'Douglas', disabled: false }
  ],
  'NM': [
    { code: 'NM001', name: 'Antelope Wells', disabled: false },
    { code: 'NM002', name: 'Columbus', disabled: false },
    { code: 'NM003', name: 'Santa Teresa', disabled: false }
  ],
  'TX': [
    { code: 'TX001', name: 'El paso', disabled: false },
    { code: 'TX002', name: 'Tornillo', disabled: false },
    { code: 'TX003', name: 'Fort Hancock', disabled: false },
    { code: 'TX004', name: 'Presidio', disabled: false },
    { code: 'TX005', name: 'Big Bend', disabled: false },
    { code: 'TX006', name: 'Del Rio', disabled: false },
    { code: 'TX007', name: 'Eagle Pass', disabled: false },
    { code: 'TX008', name: 'Laredo', disabled: false },
    { code: 'TX009', name: 'Falon Heights', disabled: false },
    { code: 'TX010', name: 'Roma', disabled: false },
    { code: 'TX011', name: 'Rio Grande', disabled: false },
    { code: 'TX012', name: 'Los Ebanos', disabled: false },
    { code: 'TX013', name: 'Mission', disabled: false },
    { code: 'TX014', name: 'Hidalgo', disabled: false },
    { code: 'TX015', name: 'Pharr', disabled: false },
    { code: 'TX016', name: 'Donna', disabled: false },
    { code: 'TX017', name: 'Progreso', disabled: false },
    { code: 'TX018', name: 'Los Indios', disabled: false },
    { code: 'TX019', name: 'Brownsville', disabled: false },
  ],
  // Canadian cities
  'WA': [
    { code: 'WA001', name: 'Blaine', disabled: false },
    { code: 'WA002', name: 'Lynden', disabled: false },
    { code: 'WA003', name: 'Sumas', disabled: false }
  ],
  'MT': [
    { code: 'MT001', name: 'Sweet Grass', disabled: false }
  ],
  'ND': [
    { code: 'ND001', name: 'Pembina', disabled: false }
  ],
  'MN': [
    { code: 'MN001', name: 'International Falls', disabled: false }
  ],
  'MI': [
    { code: 'MI001', name: 'Detroit', disabled: false },
    { code: 'MI002', name: 'Port Huron', disabled: false },
    { code: 'MI003', name: 'Sault Ste. Marie', disabled: false }
  ],
  'NY': [
    { code: 'NY001', name: 'Alexandria Bay', disabled: false },
    { code: 'NY002', name: 'Buffalo', disabled: false },
    { code: 'NY003', name: 'Niagara Falls', disabled: false },
    { code: 'NY004', name: 'Lewiston', disabled: false },
    { code: 'NY005', name: 'Akwesasne Mohawk Territory', disabled: false },
    { code: 'NY006', name: 'Ogdensburg', disabled: false }
  ],
  'VT': [
    { code: 'VT001', name: 'Derby Line', disabled: false },
    { code: 'VT002', name: 'Highgate Springs', disabled: false },
    { code: 'VT003', name: 'Norton', disabled: false }
  ],
  'ME': [
    { code: 'ME001', name: 'Jackman', disabled: false },
    { code: 'ME002', name: 'Calais', disabled: false },
    { code: 'ME003', name: 'Houlton', disabled: false },
    { code: 'ME004', name: 'Madawaska', disabled: false }
  ],
  'BTC': [
    { code: 'BTC001', name: 'Surrey', disabled: false },
    { code: 'BTC002', name: 'Tsawwassen', disabled: false },
    { code: 'BTC003', name: 'Aldergrove', disabled: false },
    { code: 'BTC004', name: 'Abbotsford', disabled: false }
  ],
  'ALB': [
    { code: 'ALB001', name: 'Coutts', disabled: false }
  ],
  'MAN': [
    { code: 'MAN001', name: 'Emerson', disabled: false }
  ],
  'ONT': [
    { code: 'ONT001', name: 'Lansdowne', disabled: false },
    { code: 'ONT002', name: 'Fort Erie', disabled: false },
    { code: 'ONT003', name: 'Niagara Falls', disabled: false },
    { code: 'ONT004', name: 'Queenston', disabled: false },
    { code: 'ONT005', name: 'Windsor', disabled: false },
    { code: 'ONT006', name: 'Fort Frances', disabled: false },
    { code: 'ONT007', name: 'Cornwall', disabled: false },
    { code: 'ONT008', name: 'Johnstown', disabled: false },
    { code: 'ONT009', name: 'Point Edward', disabled: false },
    { code: 'ONT010', name: 'Sault Ste. Marie, Ontario', disabled: false }
  ],
  'QUE': [
    { code: 'QUE001', name: 'Stanstead', disabled: false },
    { code: 'QUE002', name: 'Philipsburg', disabled: false },
    { code: 'QUE003', name: 'Saint-Théophile', disabled: false },
    { code: 'QUE004', name: 'Stanhope', disabled: false }
  ],
  'NB': [
    { code: 'NB001', name: 'St. Stephen', disabled: false },
    { code: 'NB002', name: 'Woodstock', disabled: false },
    { code: 'NB003', name: 'Edmundston', disabled: false }
  ]
};